// @flow
import React from "react"
import warner from "../images/ga-warner.png"
import wordBrown from "../images/ga-wordbrown.png"
import lisi from "../images/ga-lisi.png"
import benefitMall from "../images/ga-benefit-mall.png"
import bp from "../images/ga-bp.png"
import claremont from "../images/ga-claremont.png"
import pgp from "../images/ga-pgp.png"
import rogers from "../images/ga-rogers.png"

const logos = [warner, wordBrown, lisi, benefitMall, bp, claremont, pgp, rogers]

const GALogos = () => (
  <div css={styles.wrapper}>
    {logos.map(logo => <img src={logo} key={logo} />)}
  </div>
)

const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
}

export default GALogos



// WEBPACK FOOTER //
// ./src/components/GALogos.js